import React, { useState, useEffect } from "react";
import getServices from "../../Services/get-service";
import Constant from "../../Constant";

// Mint-boxed SVG Icons matching the design
export const WalletIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="4" width="20" height="16" rx="3.5" fill="#F59E0B" />
    <path
      d="M14 10C14 8.89543 14.8954 8 16 8H22V16H16C14.8954 16 14 15.1046 14 14V10Z"
      fill="#D97706"
    />
    <circle cx="17.5" cy="12" r="1.5" fill="#FFFFFF" />
  </svg>
);

export const CardIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="5" width="20" height="14" rx="3" fill="#F59E0B" />
    <rect x="2" y="8.5" width="20" height="3" fill="#D97706" />
    <rect
      x="5"
      y="14"
      width="4"
      height="2.5"
      rx="0.5"
      fill="#FFFFFF"
      fillOpacity="0.8"
    />
  </svg>
);

export const MastercardBadge = () => (
  <div className="flex items-center -space-x-1.5 ml-1">
    <div className="w-3.5 h-3.5 rounded-full bg-[#EB001B]" />
    <div className="w-3.5 h-3.5 rounded-full bg-[#F79E1B] opacity-90" />
  </div>
);

export const VisaBadge = () => (
  <span className="text-[11px] font-black italic tracking-tighter text-[#1A1F71] bg-gray-100 px-1 py-0.5 rounded border border-gray-200 ml-1">
    VISA
  </span>
);

export default function PaymentMethod({
  value,
  onChange,
  selectedCard,
  walletBalance: externalBalance,
}) {
  const [internalValue, setInternalValue] = useState(() => {
    return sessionStorage.getItem("paymentMethod") || "WALLET";
  });
  const [walletBalance, setWalletBalance] = useState(externalBalance || 50000.89);

  const activeValue = value !== undefined ? value : internalValue;

  const handleSelect = (method) => {
    if (onChange) {
      onChange(method);
    } else {
      setInternalValue(method);
      sessionStorage.setItem("paymentMethod", method);
    }
  };

  useEffect(() => {
    if (externalBalance !== undefined) {
      setWalletBalance(externalBalance);
    } else {
      getServices
        .getWalletBalance()
        .then((res) => {
          if (res.data?.statusCode === 200 && res.data.data?.length > 0) {
            setWalletBalance(res.data.data[0].availableBalance);
          }
        })
        .catch(() => {});
    }
  }, [externalBalance]);

  const cardLast4 = selectedCard?.last4 || "2898";
  const cardBrand = selectedCard?.brand || "mastercard";

  return (
    <div className="space-y-3 w-full">
      {/* Wallet Option */}
      <div
        onClick={() => handleSelect("WALLET")}
        className={`w-full rounded-2xl border p-3.5 flex justify-between items-center cursor-pointer transition ${
          activeValue === "WALLET"
            ? "border-[#00BC67] bg-white ring-1 ring-[#00BC67]/20 shadow-2xs"
            : "border-gray-200/90 bg-white hover:border-gray-300"
        }`}
      >
        <div className="flex items-center gap-3.5">
          <div className="w-11 h-11 rounded-xl bg-[#D4F6E6] flex items-center justify-center shrink-0">
            <WalletIcon />
          </div>
          <span className="font-[700] text-[15px] text-[#1E222B]">Wallet</span>
        </div>

        <div className="flex items-center gap-3">
          <span className="font-[700] text-[14px] text-[#1E222B]">
            NGN {Constant.FormatNumber(walletBalance)}
          </span>
          <div
            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
              activeValue === "WALLET"
                ? "border-[#00BC67]"
                : "border-gray-300"
            }`}
          >
            {activeValue === "WALLET" && (
              <div className="w-2.5 h-2.5 rounded-full bg-[#00BC67]" />
            )}
          </div>
        </div>
      </div>

      {/* Card Option */}
      <div
        onClick={() => handleSelect("CARD")}
        className={`w-full rounded-2xl border p-3.5 flex justify-between items-center cursor-pointer transition ${
          activeValue === "CARD"
            ? "border-[#00BC67] bg-white ring-1 ring-[#00BC67]/20 shadow-2xs"
            : "border-gray-200/90 bg-white hover:border-gray-300"
        }`}
      >
        <div className="flex items-center gap-3.5">
          <div className="w-11 h-11 rounded-xl bg-[#D4F6E6] flex items-center justify-center shrink-0">
            <CardIcon />
          </div>
          <span className="font-[700] text-[15px] text-[#1E222B]">Card</span>
        </div>

        <div className="flex items-center gap-2.5">
          <span className="font-[700] text-[14px] text-[#1E222B]">
            **** {cardLast4}
          </span>
          {cardBrand === "visa" ? <VisaBadge /> : <MastercardBadge />}
          <div
            className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ml-1 transition-colors ${
              activeValue === "CARD"
                ? "border-[#00BC67]"
                : "border-gray-300"
            }`}
          >
            {activeValue === "CARD" && (
              <div className="w-2.5 h-2.5 rounded-full bg-[#00BC67]" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
